import { motion } from "framer-motion";
import { X, Plus } from "lucide-react";
import ArrowDisplay from "@/components/ArrowDisplay";
import DirectionPad from "./DirectionPad";
import CategoryEditor from "./CategoryEditor";
import { scaleIn } from "@/utils/motion";

const AddStratagemModal = ({
  newStratagem,
  setNewStratagem,
  newCategoryInput,
  setNewCategoryInput,
  addNewDirection,
  removeNewLastDirection,
  clearNewDirections,
  addNewCategory,
  removeNewCategory,
  createStratagem,
  resetNewStratagem,
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80" data-testid="add-stratagem-modal">
    <motion.div
      {...scaleIn}
      className="w-full max-w-lg mx-4 hud-card clip-corners p-6 border border-green-500/50"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-headings text-2xl uppercase tracking-widest text-green-400">Add New Stratagem</h2>
        <button onClick={resetNewStratagem} className="text-gray-400 hover:text-white" data-testid="add-modal-close">
          <X className="h-6 w-6" />
        </button>
      </div>
      <p className="text-sm text-gray-400 mb-4">Manually add a stratagem that isn&apos;t in the GitHub source yet.</p>

      <div className="space-y-4">
        <div>
          <label className="text-xs text-gray-500 mb-1 block">Name *</label>
          <input
            value={newStratagem.name}
            onChange={(e) => setNewStratagem((p) => ({ ...p, name: e.target.value }))}
            className="w-full bg-black/50 border border-white/10 text-white font-data text-sm py-2 px-3 focus:border-green-400 outline-none"
            placeholder="e.g. MG-43 Machine Gun"
            data-testid="add-stratagem-name"
          />
        </div>
        <div>
          <label className="text-xs text-gray-500 mb-1 block">Primary Category</label>
          <input
            value={newStratagem.category}
            onChange={(e) => setNewStratagem((p) => ({ ...p, category: e.target.value }))}
            className="w-full bg-black/50 border border-white/10 text-white font-data text-sm py-2 px-3 focus:border-green-400 outline-none"
            placeholder="e.g. Patriotic Administration Center"
            data-testid="add-stratagem-category"
          />
        </div>
        <CategoryEditor
          categories={newStratagem.categories}
          inputValue={newCategoryInput}
          onInputChange={setNewCategoryInput}
          onAdd={addNewCategory}
          onRemove={removeNewCategory}
          accentBorder="border-green-400/40"
          accentText="text-green-400"
        />
        <div>
          <label className="text-xs text-gray-500 mb-1 block">Code Sequence *</label>
          <div className="mb-3">
            <ArrowDisplay sequence={newStratagem.code} size="sm" testIdPrefix="add-stratagem" />
          </div>
          <DirectionPad
            onDirection={addNewDirection}
            onBackspace={removeNewLastDirection}
            onClear={clearNewDirections}
            accent="#4ade80"
            testIdPrefix="add"
          />
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={resetNewStratagem}
            className="border border-white/20 px-4 py-2 text-sm font-data text-gray-300"
            data-testid="add-stratagem-cancel"
          >
            Cancel
          </button>
          <button
            onClick={createStratagem}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-500 px-4 py-2 text-sm font-data text-white"
            data-testid="add-stratagem-submit"
          >
            <Plus className="h-4 w-4" />
            Add Stratagem
          </button>
        </div>
      </div>
    </motion.div>
  </div>
);

export default AddStratagemModal;
